import NewMainVerify from '@comp/GoodpayVerify/newVerifyMain';
import CustomFailed from '@root/components/CustomFailed';
import CustomSuccess from '@root/components/CustomSuccess';
import {
  formVerifyData,
  getGoodPayContentData
} from '@root/constants/formData';
import {
  goodpayVerify,
  goodpayVerifyFailed,
  goodpayVerifySuccess
} from '@root/constants/paths';

const { main } = getGoodPayContentData();

export const getGoodPayVerifyRoutes = () => [
  {
    path: goodpayVerify(),
    element: (
      <NewMainVerify
        mainContent={main}
        formData={formVerifyData}
        redirectPaths={{
          success: goodpayVerifySuccess,
          failed: goodpayVerifyFailed
        }}
      />
    )
  },
  {
    path: goodpayVerifySuccess(),
    element: <CustomSuccess />
  },
  {
    path: goodpayVerifyFailed(),
    element: <CustomFailed />
  }
];
